import React from 'react';
import { getBackToAppLink } from '../utils/utils';

const handleBackToApp = () =>  window.location.href = getBackToAppLink();

const FallBackComponent = () => {
    return (
        <div className="text-center">
            <div className="close-container">
                <div className="icon-prop close-img"></div>
            </div>
            <div className="not-authorized" aria-describedby="Something went wrong">
               Something went wrong
            </div>
            <div>Please try again later.</div>
            <section className="card-buttons">
                <button aria-label="Back to app" onClick={handleBackToApp} className="zb-button zb-button-primary back-btn" >Back to app</button>
            </section>
        </div>
    );
  }
  export default FallBackComponent;